<template>
  <div>
    <el-card shadow="always" style="margin: 0 auto; margin-top: 5px;">
      <!-- 標題區 -->
      <el-row>
        <el-col :span="24">
          <h2 style="margin: 0 0 10px 0;">店家管理加值服務項目</h2>
        </el-col>
      </el-row>
      
      <!-- 查詢區 -->
      <el-row :gutter="15">
        <!-- 查詢與輸入 -->
        <el-col :span="5" style="display: flex; align-items: center;">
          <label style="width: 50px;">店家</label>
          <el-select v-model="qStoreId" filterable placeholder="請選擇店家" style="width: 220px">
            <el-option v-for="item in selectStores" :key="item.code" :label="item.disName" :value="item.code" />
          </el-select>
        </el-col>
        <el-col :span="6" style="display: flex; align-items: center;">
          <label style="width: 80px;">項目名稱</label>
          <el-input v-model="qServiceName" placeholder="請輸入項目名稱" style="flex: 1;" />
        </el-col>

        <!-- 查詢與重置按鈕 -->
        <el-col :span="4">
          <el-button type="primary" @click="query">查詢</el-button>
          <el-button plain @click="queryReset">重置</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 15px">
        <el-col>
          <el-button type="success" icon="el-icon-plus" @click="createDetailForm">新增服務項目</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="always" style="margin: 0 auto; margin-top: 10px;">
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="serviceName" label="項目名稱" width="120"></el-table-column>
        <el-table-column prop="storeName" label="店家" width="250"></el-table-column>
        <el-table-column prop="price" label="單價" width="80"></el-table-column>
        <el-table-column prop="status" label="狀態" width="80">
          <template slot-scope="scope">
            <el-tag :type="statusTypeMap[scope.row.status]">
              {{ statusTextMap[scope.row.status] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="displayOrder" label="顯示排序" width="100"></el-table-column>
        <el-table-column prop="updateDate" label="更新日期" :formatter="formatDate" width="160"></el-table-column>
        <el-table-column prop="updator" label="更新者" width="120"></el-table-column>
        <el-table-column prop="createDate" label="新增日期" :formatter="formatDate" width="160"></el-table-column>
        <el-table-column prop="creator" label="新增者" width="120"></el-table-column>
        <el-table-column fixed="right" label="編輯" width="">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="showDetailForm(scope.row)">編輯</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        style="margin-top:10px"
        :total="pageTotal"
        :current-page.sync="pageCurrent"
        @current-change="query"
      />
    </el-card>

    <el-dialog title="編輯視窗" :visible.sync="dialogFormVisible">    
      <el-form :model="form" ref="editForm" :rules="rules">
        <el-form-item label="項目名稱" :label-width="formLabelWidth">
          <el-input v-model="form.serviceName" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="店家" prop="storeId" :label-width="formLabelWidth">
          <el-select v-model="form.storeId" filterable placeholder="請選擇店家" style="width: 240px" @change="onChangeStore">
            <el-option
            v-for="item in selectStores"
            :key="item.code"
            :label="item.disName"
            :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="單價" :label-width="formLabelWidth" prop="price">
          <el-input v-model="form.price" autocomplete="off" />
        </el-form-item>
        <el-form-item label="狀態" prop="status" :label-width="formLabelWidth">
          <el-select v-model="form.serviceStatus" placeholder="請選填狀態" style="width: 240px">
          <el-option
            v-for="item in serviceStatuOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEditStore">確定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增視窗" :visible.sync="dialogCreateVisible">
      <el-form :model="createForm" ref="createForm" :rules="rules">
        <el-form-item label="項目名稱" prop="serviceName" :label-width="formLabelWidth">
          <el-input v-model="createForm.serviceName" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="店家" prop="storeId" :label-width="formLabelWidth">
          <el-select v-model="createForm.storeId" filterable placeholder="請選擇店家" style="width: 240px" @change="onChangeStore">
            <el-option
            v-for="item in selectStores"
            :key="item.code"
            :label="item.disName"
            :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="單價" prop="price" :label-width="formLabelWidth">
          <el-input v-model="createForm.price" autocomplete="off" />
        </el-form-item>
        <el-form-item label="狀態" prop="status" :label-width="formLabelWidth">
          <el-select v-model="createForm.serviceStatus" placeholder="請選填狀態" style="width: 240px">
          <el-option
            v-for="item in serviceStatuOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCreateVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCreateStore">確定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  created () {
    this.$axios.get('../api/params/getParams',{}).then((res)=>{
      this.$store.dispatch('login',res.data)
      this.selectStores = []
      res.data.authStores.forEach(e => {
        this.selectStores.push(e)
      })
      this.query()
    }).catch((res)=>{
      if(res.response.status==401){
        window.location = '/'
      }
    })
  },
  name: 'AdminAddOn',
  data () {
    return {
      qStoreId:'',
      qServiceName:'',
      selectStores: [],
      tableData: [],
      form:{
        id: '',
        serviceName: '',
        storeId: '',
        storeName: '',
        price: '',
        serviceStatus: ''
      },
      createForm: {
        serviceName: '',
        storeId: '',
        storeName: '',
        price: '0',
        serviceStatus: 'F'
      },
      serviceStatuOptions: [
        { value: 'T', label: '啟用'},
        { value: 'F', label: '停用'}
      ],
      statusTypeMap: {
        'T': '',
        'F': 'danger'
      },
      statusTextMap: {
        'T': '啟用',
        'F': '停用'
      },
      formLabelWidth: '120px',
      rules: {
        serviceName: [
          { required: true, message: '項目名稱為必填', trigger: 'blur' }
        ],
        storeId: [
          { required: true, message: '無法為空值', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '單價為必填', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '請輸入有效的數字', trigger: 'blur' }
        ]
      },
      pageTotal: 0,
      pageCurrent: 1,
      dialogFormVisible: false,
      dialogCreateVisible: false
    }
  },

  methods: {
    formatDate(row, column, cellValue) {
      return moment(cellValue, 'YYYYMMDDHHmmss').format('YYYY/MM/DD HH:mm:ss')
    },
    onChangeStore(storeId) { // el-select傳storeId值
      const selectedStore = this.selectStores.find(item => item.code === storeId)
      if (selectedStore) {
        this.createForm.storeName = selectedStore.disName;
        this.form.storeName = selectedStore.disName;
      }
    },
    // 查詢
    query () {
      this.$axios.get('../api/storeAddOn/getStoreAddOn', {
        params: {
          qStoreId: this.qStoreId,
          qServiceName: this.qServiceName.trim()
        }
      }).then((res) => {
          this.tableData = res.data
      }).catch((error) => {
        console.log('查詢失敗', error)
      })
    },
    // 重置
    queryReset () {
      this.qStoreId = ''
      this.qServiceName = ''
      this.query()
    },
    // 編輯(彈跳視窗)
    showDetailForm (row) {
      this.form.id = row.id
      this.form.serviceName = row.serviceName
      this.form.storeId = Number(row.storeId)  // row.storeId出來是int, this.form.storeId要對的值是string
      this.form.storeName = row.storeName
      this.form.price = row.price
      this.form.serviceStatus = row.status
      this.dialogFormVisible = true
    },
    // 確認編輯
    confirmEditStore () {
      this.$confirm('確認要編輯嗎?', '注意', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        this.$axios.post('../api/storeAddOn/updateStoreAddOn', {
          id: this.form.id,
          storeId: this.form.storeId,
          storeName: this.form.storeName,
          serviceName: this.form.serviceName.trim(),
          price : this.form.price,
          status : this.form.serviceStatus
        }).then(((res) => {
          if(res.data.rs === 'success') {
            this.$notify({
              title: '結果',
              message: '已成功修改編輯',
              type: 'success',
              duration: 4500,
              position: 'top-right',
              showClose: true
            })
            this.dialogFormVisible = false
          } else if (res.data.rs === 'fail') {
            this.$alert(res.data.rsMsg, '結果', { // 請確認，該店家已有同樣服務項目
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          } else if (res.data.rs === 'error') {
            this.$alert(res.data.rsMsg, '結果', { // 新增發生錯誤，請通知資訊人員
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          } else {
            this.$alert('發生錯誤，請通知資訊人員', '結果', {
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          }
        })).finally(() => {
          this.fullscreenLoading = false
          this.query()
        })
      })
    },
    // 新增(彈跳視窗)
    createDetailForm () {
      this.createForm.serviceName = ''
      this.createForm.storeId = ''
      this.createForm.price = ''
      this.dialogCreateVisible = true
    },
    // 確認新增
    confirmCreateStore () {
      let serviceName = this.createForm.serviceName.trim()
      let storeName = this.createForm.storeName
      let price = this.createForm.price
      if (serviceName == '' || serviceName == null || storeName == '' || storeName == null || price == '' || price == null) {
        this.$alert("欄位不得為空，否則不能新增", "結果", { confirmButtonText: "確定" })
        return
      }

      this.$confirm('確認要新增嗎?', '注意', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        this.$axios.post('../api/storeAddOn/createStoreAddOn', {
          storeId: this.createForm.storeId,
          storeName: this.createForm.storeName,
          serviceName: this.createForm.serviceName.trim(),
          price : this.createForm.price,
          status : this.createForm.serviceStatus
        }).then((res) => {
          if(res.data.rs === 'success') {
            this.$notify({
              title: '結果',
              message: '已成功新增',
              type: 'success',
              duration: 4500,
              position: 'top-right',
              showClose: true
            })
            this.dialogCreateVisible = false
          } else if (res.data.rs === 'fail') { // 請確認，該店家已有同樣服務項目
            this.$alert(res.data.rsMsg, '結果', {
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          } else if (res.data.rs === 'error') {
            this.$alert(res.data.rsMsg, '結果', { // 新增發生錯誤，請通知資訊人員
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          } else {
            this.$alert('發生錯誤，請通知資訊人員', '結果', {
              onfirmButtonText: '確定',
              type: 'error',
              showClose: true,
            })
          }
        }).finally(() => {
          this.fullscreenLoading = false
          this.query()
        })
      })

    }
  }
}
</script>
